<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="company-mortgage-form__form astral-content-width astral-stack-l">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <app-autocomplete-remote
            [control]="form.controls['companyId']"
            [service]="companyService"
            [defaultSearch]="'*'"
            (itemSelected)="onCompanySelected($event)"
          ></app-autocomplete-remote>
          <app-autocomplete-remote
            [control]="form.controls['creditInstituteId']"
            [service]="creditInstituteService"
            [defaultSearch]="'*'"
          ></app-autocomplete-remote>
          <astral-input [control]="form.controls['name']"></astral-input>
        </astral-layout-group>

        @if (form.controls['initialAmount'].value) {
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
            <app-money-box [control]="form.controls['initialAmount']"></app-money-box>
            <app-money-box [control]="form.controls['balance']"></app-money-box>
          </astral-layout-group>
        }

        @if (!dataContext.isNew) {
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
            <astral-input [control]="form.controls['currentInterestRate']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
            <astral-date-picker [control]="form.controls['nextInterestRateChangeDate']"></astral-date-picker>
          </astral-layout-group>
        }
      </section>

      @if (amortizations.length) {
        <section class="astral-section-surface astral-stack-m">
          <h3 class="astral-section-heading">{{ 'MORTGAGE.AMORTIZATIONS' | translate }}</h3>

          @for (aform of $any(amortizations.controls); track aform) {
            <div class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle">
              <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                <astral-date-picker [control]="aform.controls['paymentDate']"></astral-date-picker>
                <app-money-box [control]="aform.controls['amount']"></app-money-box>
              </astral-layout-group>
            </div>
          }
        </section>
      }
    </form>
  }
</section>
